import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route, Redirect, useHistory } from "react-router-dom";
import "./animation.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NotFoundPage from "./componetns/pages/notFoundPage";
import * as ctf from "contentful";
import DeskTopHome from "./componetns/pages/deskTopHome";
import MobileIndex from "./assets/mobileComponents";
import MobileAbout from "./assets/mobileComponents/mobileAbout";
import MobileContact from "./assets/mobileComponents/mobileContact";
import MobileProjects from "./assets/mobileComponents/mobileProjects";
import ProjectDetail from "./assets/mobileComponents/projectDetail";
import MobileNews from "./assets/mobileComponents/mobileNews";
import NewsDetail from "./assets/mobileComponents/newsDetail";
import ReelsMobile from "./assets/mobileComponents/reels";

function App() {
  // const [locationKeys, setLocationKeys] = useState([])
  // const history = useHistory()


  return (
    <>
      <div className="desktop_data">
        <BrowserRouter>
          <Switch>
            <Route path="/" exact component={DeskTopHome} />
            <Route path="/404" component={NotFoundPage} />
            <Redirect to="/404" />
            {/* <HomePage news={news} projects={projects} home={homeData} /> */}
          </Switch>
        </BrowserRouter>
      </div>
      <div className="mobile_data">
        {/* <MobileIndex /> */}
        {/* <MobileAbout /> */}
        {/* <MobileContact /> */}
        {/* <MobileProjects projects={projects} /> */}
        {/* <ProjectDetail projects={projects} /> */}
        <BrowserRouter>
          <Switch>
            <Route path="/" exact component={MobileIndex} />
            <Route path="/about" exact component={MobileAbout} />
            <Route path="/contact" exact component={MobileContact} />
            <Route path="/projects" exact component={MobileProjects} />
            <Route path="/reels" exact component={ReelsMobile} />
            <Route path="/projects/:id" exact component={ProjectDetail} />
            <Route path="/news" exact component={MobileNews} />
            <Route path="/news/:id" exact component={NewsDetail} />
            <Route path="/404" component={NotFoundPage} />
            <Redirect to="/404" />
          </Switch>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
